import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";
import Swal from "sweetalert2";

const Cashout = () => {
    const [balance, setBalance] = useState(0);
    const [authorId] = useState(localStorage.getItem('authorId'));
    const [show, setShow] = useState(false);
    const [amount, setAmount] = useState('');

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    const fetchBalance = async () => {
        try {
            const response = await fetch(`${API_URL}/authors/dashboard`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            const data = await response.json();
            if (response.ok) {
                setBalance(data.balance || 0);
            }
        } catch (error) {
            console.error('Error fetching balance:', error);
        }
    };

    useEffect(() => {
        fetchBalance();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const amountNum = parseFloat(amount);
        if (!amount || isNaN(amountNum) || amountNum <= 0) {
            Swal.fire({ text: "Please enter a valid amount.", icon: "warning" });
            return;
        }

        if (amountNum < 35) {
            Swal.fire({ text: "Minimum withdrawal amount is $35.", icon: "warning" });
            return;
        }

        try {
            const response = await fetch(`${API_URL}/authors/withdraw`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token()}`
                },
                body: JSON.stringify({ amount: amountNum })
            });

            const data = await response.json();

            if (response.ok) {
                Swal.fire({ text: "Withdrawal request submitted! It will be processed within 48 hours.", icon: "success" });
                setAmount('');
                fetchBalance(); // refresh balance
            } else {
                Swal.fire({ text: data.error || "Withdrawal failed.", icon: "error" });
            }
        } catch (error) {
            console.error("Withdrawal error:", error);
            Swal.fire({ text: "An error occurred.", icon: "error" });
        }
    };

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />
                        <div className="container">
                            <div className="page-inner">
                                <form onSubmit={handleSubmit} className="page-inner">
                                    <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                        <h3 className="fw-bold mb-3">Available Balance: ${balance}</h3>
                                    </div>
                                    <p className="fw-bold mb-3">Minimum withdrawal is $35. Withdrawals are processed within 48 hours.</p>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label htmlFor="amount">Amount ($)</label>
                                            <input
                                                type="number"
                                                name="amount"
                                                id="amount"
                                                className="form-control"
                                                style={{ border: '0.5px solid #1e3a8a' }}
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                required
                                                min="35"
                                                step="0.01"
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            <label>&nbsp;</label>
                                            <button type="submit" className="btn form-control" style={{ backgroundColor: '#1e3a8a', color: '#ffffff' }}>
                                                Request Withdrawal
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default Cashout;